module.exports = {"ja":{},"en":{}}


//////////////////
// WEBPACK FOOTER
// ./src/messages.json
// module id = S8TV
// module chunks = 24